import React from 'react';

import "./ordersPageStyles.scss"

import ButtonBack from "../../../components/Buttons/buttonBack/ButtonBack";
import {useOrderGroups} from "../hooks/useOrderGroups/useOrderGroups";
import {NavLink} from "react-router-dom";

const OrdersPage = () => {

    const { orderGroups } = useOrderGroups()

    return (
        <div className={"order_page max--width--control"}>
            <ButtonBack/>

            <div className={"order_page"}>

                <div className={'title'}>Группы заказов:</div>

                {orderGroups.map((orderGroup) => (
                    <NavLink
                        className={"item"}
                        key={orderGroup.statuses_id}
                        id={orderGroup.statuses_id}
                        to={`/Orders/${orderGroup.statuses_id}`}
                        state={{
                            data: orderGroup.statuses_id,
                            group_name: orderGroup.statuses_name,
                        }}
                    >
                        <div className={"name"}>{orderGroup.statuses_name}</div>
                        <div className={"count"}>{orderGroup.count}</div>
                    </NavLink>
                ))}

            </div>

        </div>
    );
};

export default OrdersPage;